$(document).ready(() => {
	async function main() {
		if ($(".home-header-callouts-container").length) {
			console.log("howdy console inspector!");

			// Grab the callout singles~
			let callouts = $(".callout-single");

			let calloutKeys = $.makeArray(callouts);

			let index = 0;

			for (const callout of calloutKeys) {
				if (calloutKeys.length - 1 === index) {
					await animationRunner(callout, true);
				} else {
					await animationRunner(callout, false);
				}

				index++;
			}
		}

		//Animation hook function
		async function animationRunner(_callout, isLast) {
			let callout = $(_callout);

			callout.addClass("fade-in");

			// Listen for the end of the fade in animation
			let fadeInComplete = () =>
				new Promise(resolve => callout.bind("animationend", resolve));
			await fadeInComplete();

			// wait for awhile~
			await timeout(3750);

			if (!isLast) {
				callout.addClass("fade-out");
				let fadeOutComplete = () =>
					new Promise(resolve =>
						callout.bind("animationend", resolve)
					);
				await fadeOutComplete();
				callout.css("display", "none");
			}
		}

		function timeout(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		}
	}
	// Janky way of encapsulating Async functions, but it doesn't block the event loop so das lit
	main();
});
